import { PathLike } from "fs";
import * as qs from "qs";
import { readConfigFile } from "utils/appConfig";

const initializeConfig = async () => {
  try {
    const config = await readConfigFile();

    const API_URL = config.VITE_YMS_APIM_URL ? `${config.VITE_YMS_APIM_URL}` : `${config.VITE_YMS_API_URL}`;
    const isApim = config.VITE_YMS_APIM_URL ? "/v1/" : "/";
    const gates = `/gates${isApim}`;
    const management = `/management${isApim}`;
    const identity = `/identity${isApim}`;
    const documentsManager = `/documents-manager${isApim}`;
    const WebsiteUrl = `${config.VITE_YMS_WEBSITE}`;
    const apimSubsKey = config.VITE_YMS_APIM_SUBS_KEY;

    const apiConfig = {
      returnRejectedPromiseOnError: true,
      timeout: 30000,
      baseURL: API_URL,
      headers: { "Content-Type": "application/json" },
      paramsSerializer: (params: PathLike) => qs.stringify(params, { indices: false }),
    };

    return {
      API_URL,
      isApim,
      gates,
      management,
      identity,
      documentsManager,
      WebsiteUrl,
      apiConfig,
      apimSubsKey,
    };
  } catch (error) {
    console.error("Erro ao inicializar configuração:", error);
    throw error;
  }
};

export default initializeConfig;
